import {
  ChatMessageDto,
  ChatRoomDto,
  CreateChatRoomDto,
  CursorBasedPaginated,
  CursorBasedPaginationQueryDto,
  SendMessageDto,
  UpdateApiProps,
} from '@orcar/common';
import { axiosInstance } from '../axiosInstance';

export const createMobiTalkChat = async ({
  companyId,
}: CreateChatRoomDto): Promise<ChatRoomDto> => {
  const response = await axiosInstance.post('/mobi-talk/chats', {
    companyId,
  });
  return response.data;
};

export const getMobiTalkMessages = async (
  roomId: number,
  params: CursorBasedPaginationQueryDto,
): Promise<CursorBasedPaginated<ChatMessageDto>> => {
  const response = await axiosInstance.get(
    `/mobi-talk/chats/${roomId}/messages`,
    {
      params,
    },
  );
  return response.data;
};

export const sendMobiTalkMessage = async ({
  id,
  input,
}: UpdateApiProps<SendMessageDto>): Promise<ChatMessageDto> => {
  const response = await axiosInstance.post(
    `/mobi-talk/chats/${id}/messages`,
    input,
  );
  return response.data;
};

export const createCheckoutSession = async (input: {
  returnUrl: string;
}): Promise<string> => {
  const response = await axiosInstance.post(
    '/mobi-talk/chats/temp/create-checkout-session',
    input,
  );
  return response.data.clientSecret;
};

export const getChatRoomsByReservationId = async (
  reservationId: string,
): Promise<ChatRoomDto[]> => {
  const response = await axiosInstance.get<CursorBasedPaginated<ChatRoomDto>>(
    `/mobi-talk/chats?reservationId=${reservationId}&limit=1`,
  );
  return response.data.data;
};

export const createReservation = async ({
  id,
}: {
  id: number;
}): Promise<void> => {
  const response = await axiosInstance.post(
    `/mobi-talk/chats/${id}/reservations`,
  );
  return response.data;
};
